import axios from 'axios';
import getAppConfig from '../../config';
import { setGlobalLoader } from '../ui/uiActions';
import { setSnackBarAlert, caughtError } from '../ui/uiActions';
import { getQueryString } from '../../components/common/functions';

import {
  ROLE_SET_INITIAL_STATE,
  ROLE_FIND_ALL,
  ROLE_VIEW
} from './roleTypes';

const config = getAppConfig();

export const viewRole = (roleId) => {
  let URL = `${config.api.URL}/role/${roleId}`;
  return (dispatch) => {
    dispatch(onSuccessViewRole({data: false}))
    axios.get(URL).then(response => {
      dispatch(onSuccessViewRole(response))
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const deleteRole = (roleId, filterInput) => {
  let URL = `${config.api.URL}/role/mark-delete/${roleId}`;
  if(filterInput.deleted === true) {
    // if record already deleted
    URL = `${config.api.URL}/role/unmark-delete/${roleId}`;
  }
  return (dispatch) => {
    axios.patch(URL).then(response => {

      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'success',
        message: `Success! role ${filterInput.deleted ? 'restored' : ' moved to trash'}`
      }))

      dispatch(findAllRoles(filterInput));
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const findAllRoles  = (filters="") => {
  let URL = `${config.api.URL}/role`;
  if(filters !== '') {
    URL = `${URL}?${getQueryString(filters)}`;
  }
  return (dispatch) => {
    dispatch(setGlobalLoader(true))
    axios.get(URL).then(response => {
      dispatch(setGlobalLoader(false))
      dispatch(onSuccessFindAllRole(response))
    }).catch(error => {
      dispatch(setGlobalLoader(false))
      dispatch(setRoleInitialState())
      dispatch(caughtError(error))
    })
  }
}
export const setRoleInitialState = () => {
  return {
    type: ROLE_SET_INITIAL_STATE
  }
}

export const onSuccessViewRole = response => {
  return {
    type: ROLE_VIEW,
    payload: response.data
  }
}

export const onSuccessFindAllRole = response => {
  return {
    type: ROLE_FIND_ALL,
    payload: response.data
  }
}
